import React, { useEffect, useState } from 'react';
import { useField } from 'react-form';
import { get } from 'lodash-es';
import { DatePickerPopup } from '@hummingbirdtechgroup/wings-ui';
import { ValidationMessage } from '../index';
const DateInput = (props) => (React.createElement(DatePickerPopup, { ...props, inputClassName: props.className, onChange: props.onChange || (() => undefined) }));
function ControlledDateInput(props) {
    const { field, validations = [], value } = props;
    const [date, setDate] = useState(value);
    const { meta: { error, isTouched, isValidating }, getInputProps, runValidation, setValue, } = useField(field, {
        validate: () => {
            const failingValidation = validations.find(validation => !validation.isValid(date));
            return get(failingValidation, 'message', false);
        },
    });
    useEffect(() => {
        setValue(value);
    }, []);
    useEffect(() => {
        runValidation();
    }, [date]);
    const handleChange = (newDate) => {
        setValue(newDate);
        setDate(newDate);
    };
    return (React.createElement(React.Fragment, null,
        React.createElement(DateInput, { ...getInputProps(props), onChange: handleChange, startDate: value }),
        !isValidating && isTouched && error && (React.createElement(ValidationMessage, null, error))));
}
DateInput.Controlled = ControlledDateInput;
export default DateInput;
//# sourceMappingURL=DateInput.js.map